// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth_Auth__2Yp0q","Auth_form":"Auth_Auth_form__21rGo"};